const shuttle = new URL('../../icons/shuttle.png', import.meta.url).href

export default {
  type: 'Shuttle',
  description: 'Shuttle',
  icon: shuttle,
  group: 'CCS',
  model: {
    type: 'Shuttle',
    left: 100,
    top: 100,
    width: 20,
    height: 20
  }
}
